import type { MouseEvent } from 'react';
import { useActionsDispatcher } from '../../../../../ActionsDispatcher';
import type { DragItemData, UseDragAndDrop, UseDragAndDropParams } from './useDragAndDrop.types';

export const useDragAndDrop = ({ sectionImageRef }: UseDragAndDropParams = {}): UseDragAndDrop => {
  const { dispatchStartItemDrag } = useActionsDispatcher();

  const startItemDrag = (
    event: MouseEvent,
    { categoryId, section, item, itemId, itemStructure, rect }: DragItemData,
  ) => {
    let boundingRect;
    if (rect) {
      boundingRect = rect;
    } else if (item && sectionImageRef && sectionImageRef.current) {
      const areaBoundingRect = sectionImageRef.current.getBoundingClientRect();
      const itemRect = item.preset.rect;
      boundingRect = {
        width: itemRect.width,
        height: itemRect.height,
        top: itemRect.y + areaBoundingRect.top,
        left: itemRect.x + areaBoundingRect.left,
      };
    } else {
      const element = event.target as Element;
      boundingRect = element.getBoundingClientRect();
    }

    dispatchStartItemDrag({
      event,
      categoryId,
      section,
      item,
      itemId,
      itemStructure,
      rect: {
        left: boundingRect.left,
        top: boundingRect.top,
        width: boundingRect.width,
        height: boundingRect.height,
      },
    });
  };

  return {
    startItemDrag,
  };
};
